var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { callGraphQL, callGraphQLAPIKey } from '../../common/common';
import { createFeedback as createFeedbackMutation, deleteFeedback as deleteFeedbackMutation } from '../../../graphql/mutations';
import { Auth } from '@aws-amplify/auth';
export var FeedbackCategory;
(function (FeedbackCategory) {
    FeedbackCategory["ISSUE"] = "ISSUE";
    FeedbackCategory["INQUIRY"] = "INQUIRY";
    FeedbackCategory["FEEDBACK"] = "FEEDBACK";
})(FeedbackCategory || (FeedbackCategory = {}));
/**
 * Creates a Feedback records. Authenticated users will automatically have their accounts linked to the request, otherwise it will be an anonymous submission.
 * @param email Email of the user creating the feedback record
 * @param title Title of the feedback record
 * @param details Details related to the feedback
 * @param category The type of feedback given
 */
export function createFeedback(email, title, details, category) {
    return __awaiter(this, void 0, void 0, function* () {
        let isUser = false;
        yield Auth.currentAuthenticatedUser()
            .then((res) => {
            isUser = true;
            return res;
        })
            .catch(() => {
            return;
        });
        const params = {
            email,
            title,
            details,
            category,
            isUser
        };
        if (isUser) {
            return callGraphQL(createFeedbackMutation, { input: params }).then((res) => { var _a; return (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.createFeedback; });
        }
        return callGraphQLAPIKey(createFeedbackMutation, { input: params }).then((res) => { var _a; return (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.createFeedback; });
    });
}
/**
 * Deletes a feedback record. Only users within the Employee group can delete Feedback.
 * @param id
 */
export function deleteFeedback(id) {
    return __awaiter(this, void 0, void 0, function* () {
        return callGraphQL(deleteFeedbackMutation, { input: { id: id } });
    });
}
